"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldLayout = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const FieldLayoutBase_1 = require("./components/FieldLayoutBase/FieldLayoutBase");
const FieldLayoutBase_styles_1 = require("./components/FieldLayoutBase/FieldLayoutBase.styles");
const FormFieldControl_1 = require("./components/FormFieldControl/FormFieldControl");
const Label_1 = require("./components/Label/Label");
const getFieldLayoutSize_1 = require("./helpers/getFieldLayoutSize");
exports.StyledFieldLayout = (0, styled_components_1.default)(FieldLayoutBase_1.FieldLayoutBase) `
    display: flex;
    padding: 0;
    flex-direction: ${({ inlineLabel }) => (inlineLabel ? 'row' : 'column')};
    flex-shrink: 1;
    flex-basis: auto;
    flex-wrap: nowrap;
  
    ${Label_1.Label.selector} {
        ${({ inlineLabel }) => inlineLabel
    ? (0, styled_components_1.css) `
                      margin-right: ${helpers_1.SIZE_S};
                      align-items: start;
                      margin-top: ${helpers_1.SIZE_S};
                  `
    : (0, styled_components_1.css) `
                      margin-bottom: ${helpers_1.SIZE_XS};
                  `}
    }

    ${FieldLayoutBase_styles_1.StyledFieldLayoutBaseControlBoxInner} {
        min-width: ${({ minWidth }) => minWidth};
        max-width: 100%;

        ${({ size, widthSize }) => (size || widthSize) &&
    (0, styled_components_1.css) `
                width: ${(0, getFieldLayoutSize_1.getFieldLayoutSize)(size, widthSize)};
                align-items: stretch;
            `}}
    }

    ${({ size, widthSize, helpTextWrap }) => helpTextWrap &&
    (0, styled_components_1.css) `
            ${FormFieldControl_1.FormFieldControl.selector} {
                width: ${(0, getFieldLayoutSize_1.getFieldLayoutSize)(size, widthSize)};
            }
        `}
`;
//# sourceMappingURL=FieldLayout.styles.js.map